import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useAuth } from "@/contexts/AuthContext";
import { redeemHandoff } from "@/lib/auth";

/** Admin handoff into an internal tenant's dashboard: /handoff/:token.
 * The admin pane already authenticated the person, so there is no form —
 * the token is redeemed once on mount (and scrubbed from the address bar,
 * like /join), then it's straight to the overview. */
export function Handoff() {
  const { token: tokenParam } = useParams();
  const tokenRef = useRef(tokenParam ?? "");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { applySession } = useAuth();

  useEffect(() => {
    window.history.replaceState({}, "", "/handoff");
    const token = tokenRef.current;
    if (!token) {
      setError("Invalid or expired link");
      return;
    }
    redeemHandoff(token)
      .then((session) => {
        applySession(session);
        navigate("/", { replace: true });
      })
      .catch((err: unknown) => setError(err instanceof Error ? err.message : "Something went wrong"));
  }, []);

  return (
    <div className="canvas-ambient relative flex h-screen items-center justify-center bg-canvas">
      {error ? (
        <div className="max-w-sm rounded-md border border-block-red/30 bg-block-red/10 px-3 py-2 text-sm text-block-red">
          {error}. Handoff links work once and expire in a minute — go back to the admin pane and click
          “View their dashboard” again.
        </div>
      ) : (
        <div className="text-sm text-fg-muted">Opening dashboard…</div>
      )}
    </div>
  );
}
